/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    makeStyles,
    Grid,
} from '@material-ui/core';
const useStyles = makeStyles(theme => ({
    documentContainer: {
        marginBottom: theme.spacing(2),
        borderBottom: '1px solid #e0e0e0',
        paddingBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 500,
    },
    linkButton: {
        color: '#fff',
        backgroundColor: '#B29A5E',
        marginRight: theme.spacing(1),
        '&:hover': {
            backgroundColor: '#B29A2E',
        },
    },
    gridContainer: {
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    customCardContent: {
        padding: theme.spacing(2),
    },
}));

const DocumentLink = ({ title, id }) => {
    const API_URL = process.env.REACT_APP_REST_API_URL;
    const viewLink = id ? `${API_URL}/files/${id}/view` : undefined;
    const downloadLink = id ? `${API_URL}/files/${id}/download` : undefined;

    const classes = useStyles();

    return (
        <Grid item xs={6}>
            <div className={classes.documentContainer}>
                <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.title}
                >
                    {title}
                </Typography>
                {id ? (
                    <>
                        <Button
                            component="a"
                            href={viewLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            className={classes.linkButton}
                            disabled={!id}
                        >
                            Voir
                        </Button>

                        <Button
                            component="a"
                            href={downloadLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            variant="contained"
                            className={classes.linkButton}
                            disabled={!id}
                        >
                            Télécharger
                        </Button>
                    </>
                ) : (
                    <Typography variant="body2" color="textSecondary">
                        (Aucune image n'est associée à ce document)
                    </Typography>
                )}
            </div>
        </Grid>
    );
};

export default function DocumentsTab(props: any) {
    const { record } = props;
    const classes = useStyles();

    const getFieldMap = documentType => {
        if (documentType === 'passport') {
            return {
                passport_file: 'Passeport',
            };
        } else {
            return {
                cni_file: 'CNI (Recto)',
                cni_back_file: 'CNI (Verso)',
                kbis_file: 'Kbis',
            };
        }
    };

    const fieldMap = getFieldMap(record?.document_type);

    return (
        <Card>
            <CardContent className={classes.customCardContent}>
                <Typography variant="h6" gutterBottom>
                    Documents (
                    {record?.document_type === 'passport' ? 'Passeport' : 'CNI'}
                    )
                </Typography>
                <Grid container spacing={2} className={classes.gridContainer}>
                    {Object.entries(fieldMap).map(([key, title]) => (
                        <DocumentLink
                            key={key}
                            title={title}
                            id={record[key]}
                        />
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
}
